<div class="menu-container">
  <div (click)="toggleMenu()">
    <i class="pi pi-bars tw-text-[--brand-color-main-text] tw-cursor-pointer tw-text-2xl"></i>
  </div>
  <div class="menu-body" [class.open]="isOpen" (click)="toggleMenu()">
    <div class="menu-overlay" ></div>
    <div class="menu-items">
      <p-menu [model]="menuItems"/>
    </div>
  </div>
</div>
